// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Srp5","question":"Question_question__1jXNQ","description":"Question_description__IkvrV"};